import { useSearch } from '@tanstack/react-router';

const MESSAGES: Record<string, string> = {
  not_invited: 'Your account has not been invited yet. Ask an owner to invite your email.',
  domain_not_allowed: 'This Google account is not allowed to sign in. Use your work account.',
  email_not_verified: 'Google reports this email as unverified.',
  deactivated: 'Your access has been deactivated.',
  account_mismatch: 'This email is linked to a different Google account.',
  sign_in_failed: 'We could not complete the sign-in. Please try again.',
};

export function LoginPage() {
  const { error, returnTo } = useSearch({ from: '/login' });
  const href = `/auth/google/start?returnTo=${encodeURIComponent(returnTo ?? '/')}`;
  return (
    <main className="login">
      <h1>Braze Brother</h1>
      {error && (
        <p role="alert" className="login__error">
          {MESSAGES[error] ?? MESSAGES.sign_in_failed}
        </p>
      )}
      <a className="button button--primary" href={href}>
        Sign in with Google
      </a>
    </main>
  );
}
